// src/live/utils/liveSourceBadge.ts
// Canonical source-badge mapping shared by LiveCard and LiveCardPreview so
// the same live session renders with the same label + color everywhere.

export interface LiveSourceBadge {
  label: string;
  className: string;
}

export const getLiveSourceBadge = (source: string | undefined): LiveSourceBadge => {
  switch (source) {
    case 'youtube': return { label: 'YouTube', className: 'bg-red-600' };
    case 'native':  return { label: 'PODCAST', className: 'bg-yellow-600' };
    case 'shorts':  return { label: 'SHORTS',  className: 'bg-purple-600' };
    case 'meeting': return { label: 'MEETING', className: 'bg-blue-600' };
    case 'event':   return { label: 'EVENT',   className: 'bg-orange-600' };
    default:        return { label: 'LIVE',    className: 'bg-red-600' };
  }
};
